import { useMutation } from '@tanstack/react-query';
import { Button, Form, Input } from 'antd';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Header from '~/App/components/Header';
import Wrapper from '~/App/components/Wrapper';
import message from '~/utils/message';
import api from '../../api';

const rules = [{ required: true, message: 'Wajib diisi' }];

const EditUserPin = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { isPending, mutate } = useMutation({
    mutationFn: (values: { newPin: string }) =>
      api.updateUserPin(id ?? '', values),
    retry: false,
    onSuccess: () => {
      message.success('Success change user pin');
      navigate('..');
    },
    onError: () => {
      message.error('Fail to change user pin');
    },
  });

  if (!id) return <Navigate to=".." />;

  return (
    <Wrapper className="max-w-[800px]">
      <Header title="Change User PIN" />
      <Form name="userForm" layout="vertical" onFinish={mutate}>
        <Form.Item label="PIN" name="newPin" rules={rules}>
          <Input.Password placeholder="PIN" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={isPending}>
          Submit
        </Button>
      </Form>
    </Wrapper>
  );
};

export default EditUserPin;
